import { App } from './models/app';
import { UserNamespace } from './state/user';
import { genericDynamicImportErrorHandler } from './utils/app';

// This sample rate was extracted from https://docs.google.com/spreadsheets/d/1iC9LLWMwh8UmLKmhqyF90xEcb_iEOvPS4f0aFx130_o.
const SAMPLE_RATE = 0.1;

export const initDatadogRUM = ({ app }: { app: App }) =>
    import('@eventbrite/real-user-monitoring')
        .then(({ initializeRealUserMonitoring }) => {
            initializeRealUserMonitoring({
                sessionSampleRate: SAMPLE_RATE,
                service: app.name,
                version: app.version,
            });
        })
        .catch(genericDynamicImportErrorHandler);

export const updateDatadogRumUser = (
    user?: Pick<UserNamespace, 'email' | 'fullName' | 'publicId'>,
) =>
    import('@eventbrite/real-user-monitoring')
        .then(({ setUser }) => {
            const { email, fullName, publicId } = user ?? {};

            setUser(
                user
                    ? {
                          id: publicId,
                          name: fullName,
                          email: email,
                      }
                    : {},
            );
        })
        .catch(genericDynamicImportErrorHandler);
